export const ENTITY_NAMES = {
  ASSIGNMENTS: 'assignments',
  CLASSROOMS: 'classrooms',
  COURSES: 'courses',
  GROUPS: 'groups',
  LEARNING_JOURNEYS: 'learningJourneys',
  LEARNING_JOURNEY_STEPS: 'learningJourneySteps',
  LOCKED_COURSE_VERSIONS: 'lockedCourseVersions',
  PUBLICATIONS: 'publications',
  STANDARDS: 'standards',
  STRANDS: 'strands',
  STUDENTS: 'students'
};

export default ENTITY_NAMES;
